/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReelSymbol from '../Reel/Symbol';
import AnimationManager from '../Utility/Component/Animation/AnimationManager';
import IAnimationEventData from '../Utility/Component/Animation/IAnimationEventData';
import ChildComponent from '../Utility/Component/ChildComponent';
import SymbolAnimation from './SymbolAnimation';
import SymbolSet from './SymbolSet';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** The game-specific data associated with a symbol. */
@cc._decorator.ccclass
export default class SymbolData extends ChildComponent<SymbolSet>
{
    /** The ID character that represents this symbol in a reel strip. */
    @property({ visible: true })
    private _symbolId: string = "A";
    /** Accessor for the ID character that represents this symbol in a reel strip. */
    public get SymbolId(): string { return this._symbolId; }

    /** The static texture to represent this symbol when not animating. */
    // @property(cc.SpriteFrame)
    // public get StaticAsset(): cc.Sprite { return this.getComponent(cc.Sprite); };

    /** Should the symbol be scaled when displayed. */
    @property({ type: cc.Float, visible: true })
    private _scaleFactor: number = 1.0;
    /** Accessor for the scale factor to be used on this symbol when displayed. */
    public get ScaleFactor(): number { return this._scaleFactor; }

    @property()
    protected zIndex: number = 0;
    public get ZIndex(): number { return this.zIndex || this.parent.node.zIndex; }

    /** @hidden */
    private _symbolAnimations: IAnimationEventData[] = [];
    public get SymbolAnimations(): IAnimationEventData[] { return this._symbolAnimations; }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.loadAnimations();
    }

    /**
     * Adds the animations associated with this symbol to its visual representation on the reels.
     * @param symbol The [[ReelSymbol]] to copy the animations to.
     */
    public CopyAnimationsForSymbol = (symbol: ReelSymbol): void =>
    {
        if (this._symbolAnimations && this._symbolAnimations.length > 0)
        {
            const animationManager: AnimationManager
                = new cc.Node(`${symbol.node.name}Animation`).addComponent(AnimationManager);

            symbol.AddAnimationManager(animationManager);

            let symbolId: string = this._symbolId;

            animationManager.Initialize(this._symbolAnimations, symbolId);
        }
    }

    /** @hidden */
    private loadAnimations(): void
    {
        this._symbolAnimations = this.getComponentsInChildren(SymbolAnimation);
    }
}
